import React from 'react';
import iconLogo from '../assets/icon-logo.png'

const Footer = () => {
  return (
    
    <footer className="bg-somax-dark text-white section-padding">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo e Descrição */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              
              <div className="h-10 p-0 flex items-center justify-center">
                <img src={iconLogo} className='h-10 mx-0' />
              </div>
              <span className="text-2xl font-bold">Somax</span>
            </div>
            <p className="text-gray-300 mb-4">
              Realizamos seus sonhos através do consórcio. Carros, caminhões e imóveis com as melhores condições do mercado.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-somax-green hover:text-somax-yellow transition-colors duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#fe7815" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M21 8v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5"/><path d="M11 21v-9c0-2.187.5-4 4-4m-6 5h6"/></g></svg>
              </a>
              <a href="https://www.instagram.com/grupo_somax_campany?igsh=MTJrbTVsemRuODRnbw%3D%3D&utm_source=qr" className="text-somax-green hover:text-somax-yellow transition-colors duration-300">
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#fe7815" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8"/><path d="M3 16V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5Z"/><path stroke-linecap="round" stroke-linejoin="round" d="m17.5 6.51l.01-.011"/></g></svg>
              </a>
              
            </div>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-somax-yellow">Contato</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-somax-green" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                </svg>
                <span>gruposomaxcampany@gmail.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-somax-green" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                </svg>
                <span>+55 (61) 98120-2595</span>
              </div>
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-somax-green" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                </svg>
                <span>Taguatinga shopping, torre B sala 1125<br/>Brasília - DF</span>
              </div>
            </div>
          </div>

          {/* Horário de Funcionamento */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-somax-yellow">Horário de Atendimento</h3>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span>Segunda - Sexta:</span>
                <span className="text-somax-green">8h às 18h</span>
              </div>
              <div className="flex justify-between">
                <span>Sábado:</span>
                <span className="text-somax-green">8h às 12h</span>
              </div>
              <div className="flex justify-between">
                <span>Domingo:</span>
                <span className="text-gray-400">Fechado</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © 2024 Somax Company. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;